import front from "./images/front.png";
import back from "./images/back.jpg";
import api from "./images/api.png";
import landin from "./images/landin.jpg";

export interface Project {
  link: string;
  code: string;
  image: string;
  subtitle: string;
  title: string;
  description: string;
}

export const projects: Project[] = [
  {
    title: "Portafolio",
    subtitle: "REACT",
    description:
      "Este es mi portafolio personal, creado con React, TypeScript y la metodología de Atomic Design. Utilicé estas tecnologías para lograr una estructura de código clara, escalable y fácil de mantener.",
    image: back,
    code: "https://gitlab.com/arielvia2013/portafolio",
    link: "https://portafolio-arielvia2013-30b528e2f29175e55cdadf74a7a958ef004a463.gitlab.io/",
  },
  {
    title: "Landing Page Blog",
    subtitle: "JavaScrip and CSS",
    description:
      "Creacion de una landing page moderna y visualmente atractiva utilizando JavaScript y CSS. El objetivo de este sitio es captar la atención de los usuarios, presentar un mensaje claro y convertir visitantes en clientes o usuarios.",
    image: front,
    code: "https://gitlab.com/arielvia2013/web-blog",
    link: "",
  },
  {
    title: "Search Song",
    subtitle: "React, Typescrip and Api Spotify",
    description:
      "Search Song está diseñada para ayudar a los usuarios a buscar canciones, artistas y álbumes a través de la API de Spotify, todo construido con React y TypeScript. La idea detrás de la aplicación es ofrecer una forma sencilla y atractiva de explorar la música disponible en Spotify, permitiendo a los usuarios buscar y descubrir nuevos contenidos fácilmente.",
    image: api,
    code: "https://github.com/juanAriel/song-search",
    link: "",
  },
  {
    title: "App Search Song",
    subtitle: "React native, Typescrip and redux",
    description:
      "Mi aplicación móvil está construida con React Native, Redux y TypeScript para ofrecer una experiencia de usuario fluida, escalable y eficiente. El objetivo de la app es proporcionar una interfaz intuitiva y funcional que permita a los usuarios realizar tareas específicas de manera rápida y sencilla.",
    image: landin,
    code: "https://github.com/juanAriel/search-song-app",
    link: "",
  },
  {
    title: "Sistema de asistencias",
    subtitle: "Php and Javascript",
    description:
      "Desarrollo de un sistema de asistencias utilizando PHP, JavaScript y CSS como parte de un curso de desarrollo web. El objetivo principal de este sistema es permitir a los administradores registrar, consultar y gestionar la asistencia de los usuarios de manera eficiente y organizada.",
    image: landin,
    code: "https://github.com/juanAriel/curso-sistema-asistencias",
    link: "",
  },
  {
    title: "Sistema de tickets",
    subtitle: "Laravel, php and javascript",
    description:
      "Desarrollo de un sistema de tickets utilizando Laravel conjuntamente con PHP y JavaScript, tambien se utilizo tailwind para la parte de estilos. El objetivo principal de este sistema es permitir a los usuarios y administradores gestionar turnos o solicitudes en entornos como atencion al cliente.",
    image: 'url-imagen',
    code: "https://github.com/juanAriel/sistema-tickets",
    link: "https://sistema-tickets-demo.onrender.com/",
  },
  {
    title: "Landing Page invitacion de graduacion",
    subtitle: "React, Tailwind CSS, EmailJS, and JavaScript",
    description:
      "Desarrollo de una landing page responsiva para una invitación de graduación con React y Tailwind CSS. Incluye un diseño moderno, información del evento, formulario de confirmación de asistencia conectado con EmailJS y notificaciones interactivas para mejorar la experiencia del usuario.",
    image: landin,
    code: "https://github.com/juanAriel/invitation-page",
    link: "https://invitation-graduation.netlify.app/",
  },
];
